import i18next from "i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import LocizeBackend from "i18next-locize-backend"
import { initReactI18next } from "react-i18next"

i18next
    .use(LocizeBackend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init(
        {
            react: {
                transSupportBasicHtmlNodes: true,
                transKeepBasicHtmlNodesFor: ["strong", "b", "i", "italic", "br", "u"]
            },
            backend: {
                projectId: process.env.LOCIZE_PORJECT_ID
            },
            detection: {
                order: ["localStorage", "navigator"],
                lookupQuerystring: "locale",
                lookupCookie: "locale",
                lookupLocalStorage: "locale"
            },
            fallbackLng: "en",
            ns: "latest",
            interpolation: {
                escapeValue: false,
                format: (value, format, lng) => {
                    if (format === 'number') {
                        return new Intl.NumberFormat(lng).format(value)
                    }
                    return value
                }
            }
        },
        () => {
            console.log(process.env.LOCIZE_PORJECT_ID)
        }
    )

export default i18next